export const checkOverflow = (element: HTMLElement, includeElementText?: boolean): boolean => {
  if (!element) return false;
  const currentOverflow = element?.style?.overflow;
  const currentWhiteSpace = element?.style?.whiteSpace;
  if (!currentOverflow || currentOverflow === 'visible') {
    element.style.overflow = 'hidden';
    if (includeElementText) {
      element.style.whiteSpace = 'nowrap';
    }
  }
  const isOverflowing = element.clientWidth < element.scrollWidth || element.clientHeight < element.scrollHeight;
  element.style.overflow = currentOverflow;
  if (includeElementText) {
    element.style.whiteSpace = currentWhiteSpace;
  }
  return isOverflowing;
};
